import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { faAngleLeft } from '@fortawesome/free-solid-svg-icons'

import { XpService } from '../xp.service'

const container = 'container' // Bootstrap container

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {
  @Input() part: any
  @Input() count: number
  @Output() countChange = new EventEmitter()

  public config: any
  public product: any
  public category: any
  public section: string
  public container = container
  public list = 0

  previous = faAngleLeft

  constructor(public xp: XpService) { }

  ngOnInit() {
    console.log('-- init products component --')
    console.log(this.part)
    this.product = undefined
    this.list = undefined
    this.part.showGallery = true
  }

  addCart(product) {
    console.log('-- add to cart --')
    console.log(product)
    let cart = localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : []
    cart.push(product)

    let count = 0
    cart.forEach((line) => count += line.count)
    this.count = count
    this.countChange.emit(this.count)
console.log('cart has ' + this.count)
    
    localStorage.setItem('cart', JSON.stringify(cart))
  }

  group(e, id) {
    id !== this.list && document.querySelectorAll('div.category-list').forEach(category => category.classList.remove('show'))
    id !== this.list && e.target.getAttribute('aria-expanded') === 'true' && e.stopPropagation()
    this.product && id === this.list && e.stopPropagation()
    this.product = undefined
    this.list = id
    this.part.showGallery = false
  }

  open(product, category, i, j) {
    console.log(`-- show product --`)
    console.log(category)
    this.section = `product-list-${i}-${j}`
    this.product = product
    this.category = category
    this.list = undefined
  }
}
